export const projectsData = [
  {
    projectName: 'S3 Caching System',
    projectDescription:
      'A high-performance caching system compatible with AWS S3. This solution supports the efficient streaming of large payloads and handles thousands of concurrent requests per second.',
  },
  {
    projectName: 'ZVault Secret Management Tool',
    projectDescription:
      'This project is for the internal housing use for the client in which the user has the full search capability. User has to login with OIDC (Azure AD SSO) and the browser maintains the session token and user has all create, edit, list, etc. permissions that their AD user possessed for vault secrets. Basically, it is a frontend project which allows user to keep and manage their secure and secret management tool.',
  },
  {
    projectName: 'E-commerce Website',
    projectDescription:
      "An e-commerce website is an online platform where businesses can sell their products or services to consumers through the internet. This website includes product catalogs and shopping cart that allow customers to purchase items with ease. The scope of the project included designing and developing the website, integrating an e-commerce platform, optimizing the user experience.",
  },
  {
    projectName: 'Detection of Adulteration in Fruits Using Machine Learning',
    projectDescription:
      "To detect adulteration of formalin (naturally occurring formalin), formaldehyde using machine learning, Internet of Things, HCHO gas sensor, Raspberry Pi4 and using supervised machine learning algorithm.",
  },
  {
    projectName: 'Portfolio Website',
    projectDescription:
      'As a developer/designer, we should definitely have our own portfolio website. There are endless benefits.',
  },
];
